var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCheckAction(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2270_2496)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.5001 14.419C11.3214 14.419 14.4191 11.3213 14.4191 7.5C14.4191 3.67872 11.3214 0.580956 7.5001 0.580956C3.67882 0.580956 0.581055 3.67872 0.581055 7.5C0.581055 11.3213 3.67882 14.419 7.5001 14.419Z",
    fill: "#1138F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.5 15C3.36483 15 0 11.6358 0 7.5C0 3.36483 3.36483 0 7.5 0C11.6358 0 15 3.36483 15 7.5C15 11.6358 11.6358 15 7.5 15ZM7.5 1.16188C4.00503 1.16188 1.16188 4.00503 1.16188 7.5C1.16188 10.995 4.00503 13.8381 7.5 13.8381C10.995 13.8381 13.8381 10.9944 13.8381 7.5C13.8381 4.00503 10.995 1.16188 7.5 1.16188Z",
    fill: "#1138F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.59373 10.2595C6.43805 10.2595 6.28931 10.1973 6.1795 10.0858L4.03582 7.90726C3.811 7.67836 3.8139 7.31121 4.04279 7.0858C4.27169 6.86156 4.63942 6.86388 4.86425 7.09278L6.57688 8.83327L10.1201 4.93108C10.3368 4.69348 10.7039 4.67663 10.9404 4.89158C11.178 5.10712 11.1954 5.47427 10.9799 5.71245L7.02363 10.0695C6.91617 10.188 6.76512 10.2566 6.60536 10.2601C6.60129 10.2595 6.5978 10.2595 6.59373 10.2595Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2270_2496"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15,
    height: 15,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckAction);
export default __webpack_public_path__ + "static/media/check-action.ddf142cd0ff2dcbce95d14956e60bf18.svg";
export { ForwardRef as ReactComponent };